import { Button } from "@jugl-web/ui-components/cross-platform";
import { SearchInput } from "@jugl-web/ui-components/cross-platform/SearchInput";
import {
  useAppVariant,
  useTranslations,
  useSearchInput,
} from "@jugl-web/utils";
import { useState, useEffect } from "react";
import { FormField } from "@jugl-web/rest-api";
import { ReactComponent as PlusIcon } from "./assets/plus.svg";
import { CustomerFieldsTable } from "../CustomerFieldsTable";
import { ManageFieldSidebar } from "../CustomerFormSideBar";

export const CustomerFieldsTab = ({
  entityId,
  variant,
}: {
  entityId: string;
  variant: "personal" | "company";
}) => {
  const { searchQuery, inputProps, reset } = useSearchInput();
  const { t } = useTranslations();
  const { isCx } = useAppVariant();
  const [manageFieldDialogState, setManageFieldDialogState] = useState<{
    isOpen: boolean;
    field: null | FormField;
  }>({
    isOpen: false,
    field: null,
  });

  useEffect(() => {
    reset();
  }, [reset, variant]);

  return (
    <div className="animate-fade-in flex flex-col gap-8 p-10">
      <div className="flex items-center justify-between gap-2">
        <div className="flex flex-col gap-2">
          <h2 className="font-secondary m-0 text-xl font-medium text-black">
            {variant === "personal"
              ? t({
                  id: "customers-page.personal-info",
                  defaultMessage: "Personal Info",
                })
              : t({
                  id: "customers-page.company-info",
                  defaultMessage: "Business Info",
                })}
          </h2>
          <span className="font-secondary text-sm text-[#828282]">
            {variant === "personal"
              ? t(
                  isCx
                    ? {
                        id: "customers-page.personal-info-tab-description.cx",
                        defaultMessage:
                          "Select which Fields you want to see as Contact Personal Info ✨",
                      }
                    : {
                        id: "customers-page.personal-info-tab-description",
                        defaultMessage:
                          "Select which Fields you want to see as Customer Contact Info ✨",
                      }
                )
              : t(
                  isCx
                    ? {
                        id: "customers-page.company-info-tab-description.cx",
                        defaultMessage:
                          "Select which Fields you want to see as Contact Business Info ✨",
                      }
                    : {
                        id: "customers-page.company-info-tab-description",
                        defaultMessage:
                          "Select which Fields you want to see as Customer Business Info ✨",
                      }
                )}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <SearchInput
            variant="filled"
            color="grey"
            className="w-[280px]"
            onClear={reset}
            {...inputProps}
          />
          <Button
            variant="contained"
            color="primary"
            iconEnd={<PlusIcon className="shrink-0" />}
            onClick={() => {
              setManageFieldDialogState({ isOpen: true, field: null });
            }}
          >
            {t({
              id: "customer-page.add-new-field",
              defaultMessage: "Add new field",
            })}
          </Button>
        </div>
      </div>
      <ManageFieldSidebar
        entityId={entityId}
        section={variant}
        isOpen={manageFieldDialogState.isOpen}
        fieldToEdit={manageFieldDialogState.field}
        onClose={() =>
          setManageFieldDialogState({ isOpen: false, field: null })
        }
      />
      <CustomerFieldsTable
        entityId={entityId}
        searchQuery={searchQuery}
        variant={variant}
        openManageFieldSidebar={(field) => {
          setManageFieldDialogState({ isOpen: true, field });
        }}
      />
    </div>
  );
};
